import classnames from 'classnames'
import React from 'react'

import './style.css'

interface LoaderBallsProps {
  size?: string,
  className?: any,
  visible?: boolean,
  titleId: string
}

const LoaderBalls = ({
  className,
  size = 'medium',
  visible = true,
  titleId
}: LoaderBallsProps) => {
  const id = `loaderBallTitle_${titleId}`

  return (
    <div
      aria-live="polite"
      className={classnames(`drift-widget-loader-balls drift-widget-loader-balls--${size}`, {
        'drift-widget-loader-balls--visible': visible,
        [className]: !!className,
      })}
    >
      <svg
        aria-labelledby={id}
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
      >
      <title id={id}>Processing... please wait</title>
        <circle cx="10" cy="20" r="9" />
        <circle cx="40" cy="20" r="9" />
        <circle cx="70" cy="20" r="9" />
      </svg>
    </div>
  )

}

export default LoaderBalls
